var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/hooks/useLibrePartner.tsx";
import React, { useCallback } from 'react';
import { Stack, Text } from '@adc/parallax-component-library';
import { CLOSE_MODAL, SHOW_MODAL } from 'Reducers/modal/types';
import i18n from 'Utilities/i18n';
import { store } from 'Utilities/store';
import { acceptOrRejectPartnerConnectionService, removePartnerService, sharingCodeValidateService } from 'Services/libre_api';
const useLibrePartner = () => {
  const removePartner = useCallback(async partnerID => {
    return removePartnerService(partnerID);
  }, []);
  const showStopSharingModal = useCallback((partnerName, titleTextKey, bodyTextKey, onRemoveClick) => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        buttonLayout: 'column',
        details: /*#__PURE__*/React.createElement(Stack, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 31,
            columnNumber: 13
          }
        }, /*#__PURE__*/React.createElement(Text, {
          color: "$text.100",
          fontWeight: "$bodyBase.strong",
          fontSize: "$bodyBase.strong",
          testID: "StopSharingModal.title",
          marginBottom: "$4",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 32,
            columnNumber: 15
          }
        }, i18n.t(titleTextKey)), /*#__PURE__*/React.createElement(Text, {
          color: "$text.100",
          fontWeight: "$bodyBase.default",
          fontSize: "$bodyBase.default",
          testID: "StopSharingModal.body",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 41,
            columnNumber: 15
          }
        }, i18n.t(bodyTextKey, {
          partnerName
        }))),
        primaryAction: {
          label: i18n.t('Global.modals.stopSharing.title'),
          destructive: true,
          onPress: () => {
            store.dispatch({
              type: CLOSE_MODAL
            });
            onRemoveClick();
          }
        },
        secondaryAction: {
          label: i18n.t('Global.microcopy.common.cancel'),
          onPress: () => store.dispatch({
            type: CLOSE_MODAL
          })
        },
        testID: 'StopSharingModal'
      }
    });
  }, []);
  const sharingCodeValidate = useCallback(async (code, yearOfBirth) => {
    try {
      const {
        partnerId
      } = await sharingCodeValidateService({
        code,
        yearOfBirth
      });
      return {
        partnerId
      };
    } catch (err) {
      const error = err;
      const errorCode = error.response?.data.code;
      if (error.response?.headers['x-attempts-remaining']) {
        const attemptsRemaining = Number(error.response.headers['x-attempts-remaining']);
        if (attemptsRemaining === 0) {
          return {
            errorCode,
            reachedMaxYobAttempts: true
          };
        }
      }
      return {
        errorCode
      };
    }
  }, []);
  const acceptOrRejectPartnerConnection = useCallback(async (partnerID, action, code, yearOfBirth) => {
    try {
      await acceptOrRejectPartnerConnectionService({
        action,
        code,
        partnerID,
        yearOfBirth
      });
      return {};
    } catch (err) {
      const error = err;
      return {
        error
      };
    }
  }, []);
  return {
    removePartner,
    showStopSharingModal,
    acceptOrRejectPartnerConnection,
    sharingCodeValidate
  };
};
export default useLibrePartner;